import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import ProgressDots from "../components/ProgressDots";
import ProductImage from "../components/ProductImage";
import PrimaryButton from "../components/PrimaryButton";
import { t } from "../services/i18n";
import { track } from "../services/analytics";
import { recordSession, completeOnboarding } from "../services/storage";

/**
 * Session guidance. Deliberately NO countdown timer and NO claim that the
 * app detects device activity - the physical Viraball ends the session
 * itself after 10 minutes (spec sections 2 and 4). Completion is manual.
 */
export default function SessionPage() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("session_screen_viewed");
  }, []);

  const markComplete = () => {
    recordSession();
    completeOnboarding();
    track("session_marked_complete");
    track("onboarding_completed");
    navigate("/routine");
  };

  return (
    <>
      <AppHeader title={t("session.title")} backTo="/modes" />
      <div className="page">
        <ProgressDots total={4} current={3} />
        <h2 className="h1">{t("session.heading")}</h2>
        <p className="sub">{t("session.body")}</p>
        <ProductImage />
        <div className="info-banner info-banner--success">{t("session.autoOff")}</div>
        <div className="info-banner">{t("session.usageNote")}</div>
        <div className="mt-auto mt-24">
          <PrimaryButton label={t("session.markComplete")} onClick={markComplete} />
          <button className="btn-link" onClick={() => navigate("/")}>
            {t("session.backToHome")}
          </button>
        </div>
      </div>
    </>
  );
}
